import { AngularFireUploadTask } from '@angular/fire/compat/storage';
import { UploadTaskSnapshot } from '@angular/fire/compat/storage/interfaces';
import { catchError, EMPTY, lastValueFrom, Observable } from 'rxjs';
import ValueObject from 'src/app/core/domain/value_object';

import { SharedDocument } from './shared_document';

interface SharedDocumentUploadProps {
  sharedDocument: SharedDocument;
  task: AngularFireUploadTask;
}

export class SharedDocumentUpload extends ValueObject<SharedDocumentUploadProps> {
  get sharedDocument(): SharedDocument {
    return this.props.sharedDocument;
  }

  get task(): AngularFireUploadTask {
    return this.props.task;
  }

  get progress(): Observable<number | undefined> {
    return this.task.percentageChanges().pipe(
      catchError(() => {
        return EMPTY;
      }),
    );
  }

  get changes(): Observable<UploadTaskSnapshot | undefined> {
    return this.task.snapshotChanges();
  }

  cancel(): boolean {
    return this.task.cancel();
  }

  async getUrl(): Promise<string> {
    await lastValueFrom(this.changes);
    return this.task.task.snapshot.ref.getDownloadURL();
  }

  private constructor(props: SharedDocumentUploadProps) {
    super(props);
  }

  public static create(props: SharedDocumentUploadProps): SharedDocumentUpload {
    return new SharedDocumentUpload(props);
  }
}
